import React, { lazy, Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { Toaster } from 'react-hot-toast'
import store from './store/index'
import { Provider } from 'react-redux'
import './index.css';
import Loading from './views/components/Loading'
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom'
import { LanguageProvider } from './context/LanguageContext'
import { ThemeProvider } from './context/ThemeContext'
const App = lazy(() => import('./App'))
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Provider store={store}>
      <ThemeProvider>
        <LanguageProvider>
          <Suspense fallback={<Loading />}>
            <App />
            <Toaster
              toastOptions={{
                position: 'top-right',
                style: {
                  background: '#283046',
                  color: 'white'
                }
              }}
            />
          </Suspense>
        </LanguageProvider>
      </ThemeProvider>
    </Provider>
  </BrowserRouter>
);
reportWebVitals();
